import clsx from 'clsx';
import type { TextareaHTMLAttributes } from 'react';
import styles from './Textarea.module.scss';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: string;
  helpText?: string;
}

export function Textarea({ className, error, helpText, ...rest }: TextareaProps) {
  return (
    <div className={styles.wrapper}>
      <textarea
        className={clsx(styles.textarea, error && 'error', className)}
        aria-invalid={Boolean(error)}
        {...rest}
      />
      {error ? (
        <div className={styles.errorText}>{error}</div>
      ) : helpText ? (
        <div className={styles.help}>{helpText}</div>
      ) : null}
    </div>
  );
}
